import React from 'react';
import s from '../../pages/PDV.module.css';
import { hojeBR } from '../../utils/data';

const fmtBRL = v =>
  Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const parsePT = v => parseFloat(String(v).replace(',', '.')) || 0;

export default function ModalSalvarVenda({ avisoDescontoFinal, modalSalvar, setModalSalvar, buscaRef, etapaSalvar, setEtapaSalvar, totalVenda, totalComDesconto, taxaEntregaHabilitada, taxaEntregaPadrao, taxaEntregaR, handleTaxaEntrega, descontoR, descontoP, handleDescontoR, handleDescontoP, descontoRRef, descontoPRef, avancarParaPgto, semPagamento, tipoMovFiscal, formasPgto, setFormasPgto, restante, subCartao, setSubCartao, selecionarDebito, confirmarDebito, selecionarCredito, bandeirasDebito, bandeirasCredito, bandeiraSel, setBandeiraSel, parcelasCartao, formaPgtoSel, setFormaPgtoSel, salvarInputRef, valorPgtoAtual, setValorPgtoAtual, adicionarPgto, pixContaId, setPixContaId, boletoContaId, setBoletoContaId, contasAbertura, cliente, fidelidadeCliente, creditoCliente, parcelasCrediario, setParcelasCrediario, parcelasBoleto, setParcelasBoleto, totalPago, troco, erroSalvar, pgtoCompleto, salvando, confirmarPagamento, confirmarBtnRef, online,
  // Só true quando vem do Pedidos/Orçamentos (ModalPagamentoVenda) — o PDV
  // não passa esses props, então o bloco de Boleto abaixo fica exatamente
  // como sempre foi lá (30 em 30 dias fixo, sem essa configuração extra).
  boletoParcelamentoAvancado, venc1Boleto, setVenc1Boleto, regraVencBoleto, setRegraVencBoleto, nDiasBoleto, setNDiasBoleto,
  codigoAutorizacaoCartao, setCodigoAutorizacaoCartao,
  pointAtivo = false, cobrarNaMaquininha, removerPgto,
}) {
  if (!modalSalvar) return null;
  return (
        <div className={s.modalOverlay}>
          <div className={s.modalSalvar}>

            {/* Barra de título com indicador de etapa */}
            <div className={s.modalTitleBar}>
              <span>F9 — Finalizar Venda</span>
              <div className={s.salvarEtapas}>
                <span className={etapaSalvar === 1 ? s.etapaAtiva : s.etapaInativa}>1 Desconto</span>
                <span className={s.etapaSeta}>›</span>
                <span className={etapaSalvar === 2 ? s.etapaAtiva : s.etapaInativa}>2 Pagamento</span>
              </div>
              <button className={s.modalClose}
                onClick={() => { setModalSalvar(false); buscaRef.current?.focus(); }}>✕</button>
            </div>

            {/* ── ETAPA 1: DESCONTO ── */}
            {etapaSalvar === 1 && (<>

              <div className={s.salvarTotalArea}>
                <span className={s.salvarTotalLabel}>Total da Venda</span>
                <span className={s.salvarTotalValor}>{fmtBRL(totalVenda)}</span>
              </div>

              <div className={s.descontoArea}>
                <div className={s.descontoCampos}>
                  <div className={s.descontoCampo}>
                    <label className={s.descontoLabel}>S — Desconto R$:</label>
                    <input
                      ref={descontoRRef}
                      className={s.descontoInput}
                      type="number"
                      min="0"
                      step="0.01"
                      value={descontoR}
                      onChange={handleDescontoR}
                      onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), descontoPRef.current?.focus())}
                      onFocus={e => e.target.select()}
                      placeholder="0,00"
                    />
                  </div>
                  <div className={s.descontoCampo}>
                    <label className={s.descontoLabel}>Desconto %:</label>
                    <input
                      ref={descontoPRef}
                      className={s.descontoInput}
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      value={descontoP}
                      onChange={handleDescontoP}
                      onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), avancarParaPgto())}
                      onFocus={e => e.target.select()}
                      placeholder="0,00"
                    />
                  </div>
                </div>

                {avisoDescontoFinal && (
                  <div style={{ fontSize: 12, color: '#92400e', margin: '4px 0' }}>{avisoDescontoFinal}</div>
                )}
                <div className={s.descontoResultado}>
                  <span className={s.descontoResultLabel}>Total com desconto:</span>
                  <span className={s.descontoResultValor}>{fmtBRL(totalComDesconto)}</span>
                </div>
              </div>

              <div className={s.salvarRodape}>
                <button className={s.salvarBtnContinuar}
                  onClick={avancarParaPgto}>
                  Continuar para Pagamento →
                </button>
                <button className={s.salvarBtnCancelar}
                  onClick={() => { setModalSalvar(false); buscaRef.current?.focus(); }}>
                  Cancelar
                </button>
              </div>
            </>)}

            {/* ── ETAPA 2: PAGAMENTO ── */}
            {etapaSalvar === 2 && (<>

              {/* Total com desconto (fixo) */}
              <div className={s.salvarTotalArea}>
                <span className={s.salvarTotalLabel}>
                  {(() => {
                    const ajustes = [
                      parsePT(descontoR) > 0 && `desconto – R$ ${fmtBRL(parsePT(descontoR))}`,
                      parsePT(taxaEntregaR) > 0 && `taxa de entrega + R$ ${fmtBRL(parsePT(taxaEntregaR))}`,
                    ].filter(Boolean);
                    return ajustes.length ? `Total (${ajustes.join(' · ')})` : 'Total da Venda';
                  })()}
                </span>
                <span className={s.salvarTotalValor}>{fmtBRL(totalComDesconto)}</span>
              </div>

              {/* Taxa de entrega (Parâmetros → PDV) — soma no total; trava depois do 1º pagamento */}
              {taxaEntregaHabilitada && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px', margin: '0 0 8px',
                  background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 6, fontSize: 13 }}>
                  <span style={{ fontWeight: 700 }}>🛵 Taxa de entrega R$</span>
                  <input type="text" inputMode="decimal" value={taxaEntregaR} placeholder="0,00"
                    disabled={formasPgto.length > 0}
                    onChange={e => handleTaxaEntrega(e.target.value)}
                    onFocus={e => e.target.select()}
                    style={{ width: 90, padding: '4px 6px', fontSize: 13, textAlign: 'right' }} />
                  {taxaEntregaPadrao > 0 && formasPgto.length === 0 && (
                    <button type="button" onClick={() => handleTaxaEntrega(taxaEntregaPadrao.toFixed(2))}
                      style={{ padding: '4px 8px', fontSize: 12, cursor: 'pointer' }}>
                      Padrão {fmtBRL(taxaEntregaPadrao)}
                    </button>
                  )}
                  {parsePT(taxaEntregaR) > 0 && formasPgto.length === 0 && (
                    <button type="button" onClick={() => handleTaxaEntrega('')}
                      style={{ padding: '4px 8px', fontSize: 12, cursor: 'pointer' }}>Sem taxa</button>
                  )}
                  {formasPgto.length > 0 && <span style={{ fontSize: 11, color: '#7a5b00' }}>remova os pagamentos para alterar</span>}
                </div>
              )}

              {/* SEM PAGAMENTO — tipo de movimento não gera financeiro */}
              {semPagamento ? (
                <div className={s.semPagamentoBox}>
                  <div className={s.semPagamentoIcon}>⊘</div>
                  <div className={s.semPagamentoTitulo}>SEM PAGAMENTO</div>
                  <div className={s.semPagamentoDesc}>
                    O tipo de movimento <strong>{tipoMovFiscal?.nome}</strong> não gera lançamento financeiro.
                    Esta venda será registrada sem forma de pagamento.
                  </div>
                </div>
              ) : (<>

              {/* Grade de formas adicionadas */}
              <div className={s.salvarPgtoWrap}>
                <table className={s.salvarPgtoGrid}>
                  <thead>
                    <tr>
                      <th>Forma de Pagamento</th>
                      <th className={s.right}>Valor R$</th>
                      <th style={{width:32}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {formasPgto.length === 0 && (
                      <tr><td colSpan={3} className={s.salvarVazio}>Nenhuma forma adicionada</td></tr>
                    )}
                    {formasPgto.map((p, i) => {
                      const nParc = p.forma === 'Crediário' ? (p.parcelas || 1) : null;
                      return (
                        <tr key={i}>
                          <td>
                            {p.forma}
                            {nParc && nParc > 1 && <span style={{color:'#6b7280',marginLeft:4,fontSize:11}}>{nParc}x</span>}
                            {p.mp_point_cobranca_id && (
                              <span title="Cobrado na maquininha Mercado Pago" style={{color:'#15803d',marginLeft:6,fontSize:11}}>
                                ✓ maquininha{p.mp_point_info ? ` · ${p.mp_point_info}` : ''}
                              </span>
                            )}
                          </td>
                          <td className={s.right}>
                            {nParc && nParc > 1
                              ? <>{fmtBRL(p.valor / nParc)}<span style={{color:'#9ca3af',fontSize:11}}>/parc</span></>
                              : fmtBRL(p.valor)}
                          </td>
                          <td>
                            <button className={s.salvarRemBtn}
                              onClick={() => (removerPgto ? removerPgto(i) : setFormasPgto(prev => prev.filter((_,j) => j !== i)))}>✕</button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Indicador de valor restante */}
              <div className={s.salvarRestanteLinha}>
                <span>Restante:</span>
                <strong className={restante > 0 ? s.salvarRestanteVermelho : s.salvarRestanteVerde}>
                  R$ {fmtBRL(restante)}
                </strong>
              </div>

              {/* Sub-opção Cartão — inline */}
              {subCartao === 'choose' && (
                <div className={s.subCartaoArea}>
                  <span className={s.subCartaoLabel}>Cartão — escolha o tipo:</span>
                  <div className={s.subCartaoBtns}>
                    <button className={s.subCartaoBtn} onClick={selecionarDebito}>
                      <kbd>D</kbd> Débito
                    </button>
                    <button className={s.subCartaoBtn} onClick={() => setSubCartao('credito')}>
                      <kbd>C</kbd> Crédito
                    </button>
                  </div>
                </div>
              )}

              {subCartao === 'debito' && (
                <div className={s.subCartaoArea}>
                  {bandeirasDebito.length > 0 && (
                    <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ fontSize: 12, color: '#555' }}>Bandeira:</span>
                      <select
                        style={{ fontSize: 12, height: 24, border: '1px solid #aaa', borderRadius: 3, padding: '0 4px' }}
                        value={bandeiraSel?.id || ''}
                        onChange={e => {
                          const b = bandeirasDebito.find(x => x.id === parseInt(e.target.value));
                          setBandeiraSel(b || null);
                        }}>
                        <option value="">— selecione —</option>
                        {bandeirasDebito.map(b => <option key={b.id} value={b.id}>{b.nome}</option>)}
                      </select>
                    </div>
                  )}
                  <button
                    className={s.subCartaoBtn}
                    style={{ background: '#1d4ed8', color: '#fff', marginTop: 4 }}
                    onClick={confirmarDebito}>
                    ✓ Confirmar Débito (Enter)
                  </button>
                </div>
              )}

              {subCartao === 'credito' && (
                <div className={s.subCartaoArea}>
                  {bandeirasCredito.length > 0 && (
                    <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ fontSize: 12, color: '#555' }}>Bandeira:</span>
                      <select
                        style={{ fontSize: 12, height: 24, border: '1px solid #aaa', borderRadius: 3, padding: '0 4px' }}
                        value={bandeiraSel?.id || ''}
                        onChange={e => {
                          const b = bandeirasCredito.find(x => x.id === parseInt(e.target.value));
                          setBandeiraSel(b || null);
                        }}>
                        <option value="">— selecione —</option>
                        {bandeirasCredito.map(b => <option key={b.id} value={b.id}>{b.nome}</option>)}
                      </select>
                    </div>
                  )}
                  <span className={s.subCartaoLabel}>Crédito — número de parcelas:</span>
                  <div className={s.parcelasGrid}>
                    {[1,2,3,4,5,6,7,8,9,10,11,12].map(n => (
                      <button
                        key={n}
                        className={`${s.parcelaBtn} ${parcelasCartao === n ? s.parcelaBtnAtivo : ''}`}
                        onClick={() => selecionarCredito(n)}>
                        {n}x
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Seleção de forma + valor — Crediário/Boleto exigem cliente identificado
                  ANTES de poder adicionar o pagamento (senão dava pra completar a
                  venda com boleto/crediário sem cliente nenhum selecionado). */}
              {!subCartao && (() => {
                const exigeCliSemSelecionar = (formaPgtoSel === 'Crediário' || formaPgtoSel === 'Boleto' || formaPgtoSel === 'Crédito do Cliente')
                  && (!cliente || cliente.id === 1);
                return (
                  <div className={s.salvarInputArea}>
                    <div className={s.salvarFormaTag}>{formaPgtoSel}</div>
                    <input
                      ref={salvarInputRef}
                      className={s.salvarInputValor}
                      type="number"
                      min="0"
                      step="0.01"
                      value={valorPgtoAtual}
                      disabled={exigeCliSemSelecionar}
                      onChange={e => setValorPgtoAtual(e.target.value)}
                      onKeyDown={e => {
                        if (e.key !== 'Enter' || exigeCliSemSelecionar) return;
                        e.preventDefault();
                        // Venda já paga → Enter confirma; senão adiciona o pagamento
                        if (pgtoCompleto) confirmarPagamento(); else adicionarPgto();
                      }}
                      onFocus={e => e.target.select()}
                      placeholder="0,00"
                    />
                    {pointAtivo && formaPgtoSel.startsWith('Cartão') && (
                      <button className={s.salvarBtnAdd} onClick={cobrarNaMaquininha}
                        title="Envia o valor para a maquininha Mercado Pago (atalho M)"
                        style={{ background: '#15803d', borderColor: '#15803d', color: '#fff', whiteSpace: 'nowrap' }}>
                        💳 Maquininha (M)
                      </button>
                    )}
                    <button className={s.salvarBtnAdd} disabled={exigeCliSemSelecionar} onClick={adicionarPgto}>+ Adicionar</button>
                  </div>
                );
              })()}

              {/* Código de autorização do cartão — SEMPRE opcional (o PDV não tem
                  POS/TEF integrado que devolva isso sozinho; o campo <cAut> do
                  grupo <card> é facultativo no schema da NF-e/NFC-e mesmo sem
                  ele). Só aparece depois de já ter escolhido débito/crédito
                  (formaPgtoSel vira "Cartão ..."), na mesma tela do valor —
                  nunca antes, pra não conflitar com os atalhos de teclado da
                  tela de bandeira/parcelas (dígitos ali escolhem parcelas). */}
              {!subCartao && formaPgtoSel.startsWith('Cartão') && (() => {
                return (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, margin: '2px 0 8px' }}>
                    <label style={{ fontSize: 11, color: '#777', whiteSpace: 'nowrap' }}
                      title="Do comprovante impresso pela maquininha — ajuda a conferir/auditar depois, mas não é obrigatório">
                      Cód. autorização:
                    </label>
                    <input
                      type="text"
                      value={codigoAutorizacaoCartao}
                      onChange={e => setCodigoAutorizacaoCartao(e.target.value)}
                      onKeyDown={e => {
                        if (e.key !== 'Enter') return;
                        e.preventDefault();
                        salvarInputRef.current?.focus(); // Enter aqui só passa pro valor — não confirma nada sozinho
                      }}
                      placeholder="opcional — ex.: 123456"
                      maxLength={30}
                      style={{ flex: 1, fontSize: 12, height: 24, border: '1px solid #ccc', borderRadius: 3, padding: '0 6px' }}
                    />
                  </div>
                );
              })()}

              {/* Barra de atalhos de forma — "Pontos Fidelidade" só aparece quando
                  o cliente selecionado tem crédito disponível pra resgatar E a
                  internet está de pé (o saldo é calculado no servidor na hora —
                  sem conexão não dá pra confiar nele nem confirmar o resgate). */}
              <div className={s.salvarAtalhos}>
                {[
                  ['B','Boleto'],['C','Cartão'],['D','Dinheiro'],['H','Cheque'],['N','Crediário'],['P','PIX'],
                  ...(online && fidelidadeCliente?.credito_disponivel > 0 ? [['F','Pontos Fidelidade']] : []),
                  ...(online && creditoCliente?.total > 0 ? [['V','Crédito do Cliente']] : []),
                ].map(([k,f]) => {
                  const ehCartao = f === 'Cartão';
                  const ehFidelidade = f === 'Pontos Fidelidade';
                  const ehCreditoCliente = f === 'Crédito do Cliente';
                  const ativo = ehCartao
                    ? (subCartao !== null || formaPgtoSel.startsWith('Cartão'))
                    : (!subCartao && formaPgtoSel === f);
                  return (
                    <button key={k}
                      className={`${s.salvarAtalhoBtn} ${ativo ? s.salvarAtalhoBtnAtivo : ''}`}
                      onClick={() => {
                        if (ehCartao) { setSubCartao('choose'); }
                        else {
                          setFormaPgtoSel(f);
                          setSubCartao(null);
                          const valorMax = ehFidelidade
                            ? Math.min(restante, fidelidadeCliente.credito_disponivel)
                            : ehCreditoCliente
                            ? Math.min(restante, creditoCliente.total)
                            : restante;
                          setValorPgtoAtual(valorMax > 0 ? valorMax.toFixed(2) : '');
                          setTimeout(() => { salvarInputRef.current?.focus(); salvarInputRef.current?.select(); }, 20);
                        }
                      }}>
                      <kbd>{k}</kbd> {f}
                    </button>
                  );
                })}
              </div>

              {/* Pontos Fidelidade: lembrete do saldo/crédito disponível */}
              {formaPgtoSel === 'Pontos Fidelidade' && !subCartao && fidelidadeCliente && (
                <div style={{ margin: '6px 0', fontSize: 12, color: '#555' }}>
                  Saldo do cliente: {fidelidadeCliente.saldo_pontos} ponto(s) — até R$ {fmtBRL(fidelidadeCliente.credito_disponivel)} disponível pra resgate nesta venda.
                </div>
              )}

              {/* Crédito do Cliente: saldo disponível (gerado por devolução) */}
              {formaPgtoSel === 'Crédito do Cliente' && !subCartao && (
                (!cliente || cliente.id === 1) ? (
                  <div style={{ margin: '8px 0' }}>
                    <span style={{ fontSize: 12, color: '#dc2626', fontWeight: 600 }}>
                      ⚠ Crédito do Cliente exige cliente identificado (diferente de VENDA CONSUMIDOR) — pressione F10 para escolher
                    </span>
                  </div>
                ) : creditoCliente && (
                  <div style={{ margin: '6px 0', fontSize: 12, color: '#555' }}>
                    💳 Crédito disponível do cliente: R$ {fmtBRL(creditoCliente.total)}
                    {restante > creditoCliente.total ? ' — a diferença pode ser paga com outra forma.' : '.'}
                  </div>
                )
              )}

              {/* PIX: seletor de conta bancária */}
              {formaPgtoSel === 'PIX' && !subCartao && (
                <div style={{ margin: '8px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <label style={{ fontSize: 12, color: '#555', whiteSpace: 'nowrap' }}>Conta PIX:</label>
                  <select
                    value={pixContaId}
                    onChange={e => setPixContaId(e.target.value)}
                    style={{ flex: 1, padding: '5px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4 }}
                  >
                    <option value="">— conta padrão da org —</option>
                    {contasAbertura.filter(c => c.tipo !== 'caixa').map(c => (
                      <option key={c.id} value={c.id}>{c.nome}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Boleto: banco emissor (só pergunta quando há mais de um banco APTO a
                  emitir boleto — integracao_boleto cora/cnab400; conta bancária comum
                  sem integração nem entra na conta); exige cliente identificado */}
              {formaPgtoSel === 'Boleto' && !subCartao && (
                <div style={{ margin: '8px 0' }}>
                  {!cliente || cliente.id === 1 ? (
                    <span style={{ fontSize: 12, color: '#dc2626', fontWeight: 600 }}>
                      ⚠ Boleto exige cliente identificado (diferente de VENDA CONSUMIDOR) — pressione F10 para escolher
                    </span>
                  ) : (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {(() => {
                          const bancosBoleto = contasAbertura.filter(c => c.tipo === 'banco' && ['cora', 'cnab400'].includes(c.integracao_boleto));
                          // Só pergunta o banco quando há de fato mais de um apto a emitir
                          // boleto (integração cora/cnab400) — uma "BANCO X" só cadastrada
                          // como conta corrente comum (integracao_boleto='nenhuma') não conta
                          // pra essa contagem e nunca deveria aparecer nesta lista, senão
                          // parece que sempre há escolha a fazer mesmo com um único banco
                          // de boleto configurado (achado ao vivo na RBDIGITAL: CORA + NUBANK
                          // — NUBANK sem integração nenhuma forçava a pergunta à toa).
                          if (bancosBoleto.length <= 1) {
                            return (
                              <span style={{ fontSize: 12, color: '#555' }}>
                                Banco do boleto: <b>{bancosBoleto[0]?.nome || 'conta padrão da organização'}</b>
                              </span>
                            );
                          }
                          return (
                            <>
                              <label style={{ fontSize: 12, color: '#555', whiteSpace: 'nowrap' }}>Banco do boleto:</label>
                              <select
                                value={boletoContaId}
                                onChange={e => setBoletoContaId(e.target.value)}
                                style={{ flex: 1, padding: '5px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4 }}
                              >
                                <option value="">— conta padrão da org —</option>
                                {bancosBoleto.map(c => (
                                  <option key={c.id} value={c.id}>
                                    {c.nome}{c.banco_codigo ? ` (${c.banco_codigo})` : ''}
                                  </option>
                                ))}
                              </select>
                            </>
                          );
                        })()}
                        <label style={{ fontSize: 12, color: '#555', whiteSpace: 'nowrap' }}>Parcelas:</label>
                        <select
                          value={parcelasBoleto}
                          onChange={e => setParcelasBoleto(parseInt(e.target.value))}
                          style={{ width: 110, padding: '5px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4 }}
                        >
                          {[1,2,3,4,5,6,7,8,9,10,11,12].map(n => (
                            <option key={n} value={n}>{n}x{boletoParcelamentoAvancado ? '' : ' (30d)'}</option>
                          ))}
                        </select>
                      </div>

                      {/* Vencimento configurável — só no Pedidos/Orçamentos (ver
                          boletoParcelamentoAvancado); no PDV segue fixo em 30 dias. */}
                      {boletoParcelamentoAvancado && (
                        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                          <label style={{ fontSize: 12, color: '#555', whiteSpace: 'nowrap' }}>Vencimento da 1ª:</label>
                          <input type="date" value={venc1Boleto} min={hojeBR()} onChange={e => setVenc1Boleto(e.target.value)}
                            style={{ padding: '5px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4 }} />
                        </div>
                      )}
                      {boletoParcelamentoAvancado && parcelasBoleto > 1 && (
                        <fieldset style={{ marginTop: 8, border: '1px solid #93c5fd', borderRadius: 4, padding: '6px 10px' }}>
                          <legend style={{ fontSize: 11.5, color: '#1e3a5f', padding: '0 4px' }}>Vencimento das Parcelas</legend>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12.5 }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              <input type="radio" name="regraVencBoleto" checked={regraVencBoleto === 'direto'}
                                onChange={() => setRegraVencBoleto('direto')} />
                              Somar 30 Dias Direto
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              <input type="radio" name="regraVencBoleto" checked={regraVencBoleto === 'mes'}
                                onChange={() => setRegraVencBoleto('mes')} />
                              Mesmo dia de Cada Mês
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              <input type="radio" name="regraVencBoleto" checked={regraVencBoleto === 'ndias'}
                                onChange={() => setRegraVencBoleto('ndias')} />
                              A cada
                              <input type="number" min="1" style={{ width: 52, padding: '2px 4px', fontSize: 12,
                                border: '1px solid #ccc', borderRadius: 3, color: '#b91c1c', fontWeight: 700 }}
                                value={nDiasBoleto}
                                onFocus={() => setRegraVencBoleto('ndias')}
                                onChange={e => setNDiasBoleto(e.target.value)} />
                              dias
                            </label>
                          </div>
                        </fieldset>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* Crediário: parcelas */}
              {formaPgtoSel === 'Crediário' && !subCartao && (
                <div style={{ margin: '8px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
                  {!cliente || cliente.id === 1 ? (
                    <span style={{ fontSize: 12, color: '#dc2626', fontWeight: 600 }}>
                      ⚠ Crediário exige cliente identificado (diferente de VENDA CONSUMIDOR) — pressione F10 para escolher
                    </span>
                  ) : (
                    <>
                      <label style={{ fontSize: 12, color: '#555', whiteSpace: 'nowrap' }}>Parcelas:</label>
                      <select
                        value={parcelasCrediario}
                        onChange={e => setParcelasCrediario(parseInt(e.target.value))}
                        style={{ width: 110, padding: '5px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4 }}
                      >
                        {[1,2,3,4,5,6,7,8,9,10,11,12].map(n => (
                          <option key={n} value={n}>{n}x (30d)</option>
                        ))}
                      </select>
                      <span style={{ fontSize: 12, color: '#555' }}>
                        Venc. 1ª: {new Date(Date.now() + 30*864e5).toLocaleDateString('pt-BR')}
                      </span>
                    </>
                  )}
                </div>
              )}

              {/* Totais */}
              <div className={s.salvarTotaisBar}>
                <div className={s.salvarTotaisItem}>
                  <span>Total pago:</span>
                  <strong className={s.salvarPagoValor}>{fmtBRL(totalPago)}</strong>
                </div>
                {troco > 0 && (
                  <div className={s.salvarTotaisItem}>
                    <span>Troco:</span>
                    <strong className={s.salvarTrocoValor}>{fmtBRL(troco)}</strong>
                  </div>
                )}
              </div>

              </>)}

              {erroSalvar && <div className={s.salvarErro}>{erroSalvar}</div>}
              <div className={s.salvarRodape}>
                <button className={s.salvarBtnVoltar}
                  onClick={() => setEtapaSalvar(1)}>
                  ← Desconto
                </button>
                <button
                  ref={confirmarBtnRef}
                  className={`${s.salvarBtnConfirmar} ${pgtoCompleto ? s.salvarBtnConfirmarAtivo : ''}`}
                  disabled={!pgtoCompleto || salvando ||
                    (formasPgto.some(p => p.forma === 'Crediário' || p.forma === 'Boleto' || p.forma === 'Crédito do Cliente') && (!cliente || cliente.id === 1))}
                  title="Confirmar pagamento (Enter)"
                  onClick={confirmarPagamento}>
                  {salvando ? 'Salvando…' : 'Confirmar pagamento'}
                </button>
                <button className={s.salvarBtnCancelar}
                  disabled={salvando}
                  onClick={() => { setModalSalvar(false); buscaRef.current?.focus(); }}>
                  Cancelar
                </button>
              </div>
            </>)}

          </div>
        </div>
  );
}
